<template>
  <v-flex xs12 v-if="sumupTransaction != null">
    <h3 style="font-weight: medium;">SumUP</h3>
    <h4 v-if="sumupTransaction.error != 'no_error'" style="color: red;">{{sumupTransaction.error}}</h4>
    <p>
      <b>Transaction Code:</b>
      {{sumupTransaction.transaction_code}}
    </p>
    <p>
      <b>Amount:</b>
      {{sumupTransaction.amount.toFixed(2)}}
    </p>
    <v-btn
      small
      class="text-none"
      target="_blank"
      href="https://me.sumup.com/en-us/sales/transactions"
    >Go to Sumup</v-btn>
  </v-flex>
</template>

<script>
import moment from "moment";

export default {
  name: "SumupTransaction",
  mounted: function() {
    console.log("SumupTransaction");
  },
  components: {},
  props: {
    bookingForm: Object
  },
  computed: {
    sumupTransaction: function() {
      if (this.bookingForm == null) {
        return null;
      }
      return this.bookingForm.booking.sumup_transaction;
    }
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}
</style>
